import { loading, success, handleErrorException } from 'State/actions';

import * as types from './types';

export const getGrades = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.SALES_ANALYSIS_GET_GRADES_LOADING, true));

      let response = await MPWWebApi.postGenericInsertUpdate(
        `Grade/GetGradeListForSiteIds`,
        siteId
      );
      dispatch(success(types.SALES_ANALYSIS_GET_GRADES, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message: 'An error occurred while getting the data. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.SALES_ANALYSIS_REPORT_ERRORS,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SALES_ANALYSIS_GET_GRADES_LOADING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/state/actions.js